/**
 * Date utility functions
 */

/**
 * Reviver function for JSON.parse that handles relative date expressions
 * Supports expressions like {now}, {now+1d}, {now-2w1200}, etc.
 * @param {string} key - The key being parsed
 * @param {any} value - The value being parsed
 * @returns {any} - The processed value (Date ISO string for date expressions, original value otherwise)
 */
export function relativeDateReviver(key, value) {
  if (value === '{now}') {
    return new Date().toISOString();
  }

  if (typeof value === 'string' && /^{now[+-]\d+[dwmyhMsS](\d{4})?}$/.test(value)) {
    const now = new Date();

    // Remove curly braces and parse
    const cleanInput = value.replace(/[{}]/g, '');
    const match = cleanInput.match(/^now([+-])(\d+)([dwmyhMsS])(\d{4})?$/);

    if (!match) {
      return value; // Return original if parsing fails
    }

    const [, operator, amount, unit, fixedTime] = match;
    const numValue = parseInt(amount);
    const multiplier = operator === '+' ? 1 : -1;

    const result = new Date(now);

    // Apply the time offset - keeping ALL original units
    switch (unit) {
      case 'd': // days
      case 'D': // days
        result.setDate(result.getDate() + (numValue * multiplier));
        break;
      case 'w': // weeks
        result.setDate(result.getDate() + (numValue * 7 * multiplier));
        break;
      case 'M': // months
        result.setMonth(result.getMonth() + (numValue * multiplier));
        break;
      case 'y': // years
      case 'Y': // years
        result.setFullYear(result.getFullYear() + (numValue * multiplier));
        break;
      case 'h': // hours      
        result.setHours(result.getHours() + (numValue * multiplier));
        break;
      case 'm': // minutes
        result.setMinutes(result.getMinutes() + (numValue * multiplier));
        break;
      case 's': // seconds
        result.setSeconds(result.getSeconds() + (numValue * multiplier));
        break;     
    }

    // If fixed time is provided, set it; otherwise keep current time
    if (fixedTime) {
      const hours = parseInt(fixedTime.substring(0, 2));
      const minutes = parseInt(fixedTime.substring(2, 4));
      result.setHours(hours, minutes, 0, 0);
    }

    return result.toISOString();
  }

  return value; // Return unchanged for non-matching values
}
